import React from 'react';
import { Col, Row } from 'react-bootstrap';
import LiveReadingsWidget from './EEReports/LiveReadingsWidget';
import PowerQualityCharts from './EEReports/PowerQaualityCharts';

const PowerQualityTab = ({ deviceId }) => (
  <Row>
    <Col md={5}>
      <LiveReadingsWidget deviceId={deviceId} />
    </Col>
    <Col md={7}>
      <PowerQualityCharts deviceId={deviceId} />
    </Col>
  </Row>
);
export default PowerQualityTab;
